var exports = {
  "M": "xe533113f--b3c1c1--price-discount",
  "m": "xe533113f--b3c1c1--old-price",
};

module.exports = exports;
